// ----------------------------------------------------------------------- react
import { useRef, useState } from "react";

// ------------------------------------------------------------------- internos
import { completarExcel, bajar } from "../services/satelitalPosiciones";

/* Subir un Excel con huecos y bajarlo completo con los datos de la empresa.
 *
 * Ticket #421 (Leonel, Satelital, 15/10): *«si yo subo un excel con espacios
 * vacíos, ¿se podrá completar automáticamente esos datos? […] como el Excel
 * que subo con posiciones pero de datos que tenés de la empresa»*.
 *
 * El gemelo de `SatelitalPosiciones`: el archivo va a FlotaBot, que devuelve
 * el MISMO Excel con las celdas vacías completadas y las que no pudo, en
 * amarillo. No escribe nada, sólo lee y devuelve. Sin textos de ayuda en la
 * pantalla: el cómo está en /como/satelital.
 */
export default function SatelitalCompletar() {
  const entrada = useRef(null);
  const [archivo, setArchivo] = useState(null);
  const [encima, setEncima] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");
  const [hecho, setHecho] = useState(null);

  const tomar = (f) => {
    setArchivo(f);
    setError("");
    setHecho(null);
  };
  const elegido = (e) => {
    const f = e.target.files?.[0];
    if (f) tomar(f);
  };
  const soltar = (e) => {
    e.preventDefault();
    setEncima(false);
    const f = e.dataTransfer.files?.[0];
    if (f) tomar(f);
  };

  const pedir = async () => {
    if (!archivo) return;
    setCargando(true);
    setError("");
    setHecho(null);
    const r = await completarExcel(archivo);
    setCargando(false);
    if (!r.ok) {
      setError(r.mensaje || "No se pudo consultar.");
      return;
    }
    bajar(r.blob, r.nombre);
    setHecho(r);
  };

  return (
    <div>
      <h2 style={{ margin: "0 0 4px" }}>Completar datos por Excel</h2>

      <div
        className={"planilla-cajon" + (encima ? " planilla-cajon--encima" : "")}
        onDragOver={(e) => {
          e.preventDefault();
          setEncima(true);
        }}
        onDragLeave={() => setEncima(false)}
        onDrop={soltar}
      >
        <p className="planilla-cajon__txt">
          Arrastrá el Excel acá
          <br />
          <span className="tk-meta">o</span>
        </p>
        <button
          type="button"
          className="tk-boton"
          onClick={() => entrada.current?.click()}
        >
          Buscar en el equipo
        </button>
        <input
          ref={entrada}
          type="file"
          accept=".xlsx,.xlsm"
          onChange={elegido}
          hidden
          aria-label="Excel para completar"
        />
        {archivo && <p className="tk-meta">{archivo.name}</p>}
      </div>

      {archivo && !cargando && (
        <p>
          <button
            type="button"
            className="tk-boton tk-boton--fuerte"
            onClick={pedir}
          >
            Completar
          </button>
        </p>
      )}

      {cargando && <p className="tk-meta">Completando…</p>}

      {error && (
        <div className="panel-aviso suave">
          <p>{error}</p>
        </div>
      )}

      {hecho && (
        <div className="panel-aviso suave">
          <h3>Listo</h3>
          <p>
            Se bajó «{hecho.nombre}».
            {hecho.completadas != null && (
              <>
                {" "}
                {hecho.completadas} celdas completadas
                {hecho.sinDato ? `, ${hecho.sinDato} en amarillo` : ""}.
              </>
            )}
          </p>
        </div>
      )}
    </div>
  );
}
